import { SelectOption } from '@doveit/bricks';
import { removeNullAndUndefinedValues } from '../utils/array';
import { CustomUser, UserRole } from '../types';

export const jobApplicationHrUsers: CustomUser[] = [
  {
    name: 'Barbara Maggioni',
    email: 'barbara.maggioni@dove.it',
    given_name: 'Barbara',
    family_name: 'Maggioni',
    picture: '/images/hr/barbara-maggioni.jpg',
    'https://backoffice.dove.it/roles': [UserRole.HR],
  },
  {
    name: 'Veronica Amore',
    email: 'veronica.amore@dove.it',
    given_name: 'Veronica',
    family_name: 'Amore',
    picture: '/images/hr/veronica-amore.jpg',
    'https://backoffice.dove.it/roles': [UserRole.HR],
  },
  {
    name: 'Nunzia Polese',
    email: 'nunzia.polese@dove.it',
    given_name: 'Nunzia',
    family_name: 'Polese',
    picture: '/images/hr/nunzia-polese.jpg',
    'https://backoffice.dove.it/roles': [UserRole.HR],
  },
  {
    name: 'Francesco Bona Galvagno',
    email: 'francesco.bonagalvagno@dove.it',
    given_name: 'Francesco',
    family_name: 'Bona Galvagno',
    picture: '/images/hr/francesco-bona-galvagno.png',
    'https://backoffice.dove.it/roles': [UserRole.HR],
  },
];

export const jobApplicationAssigneeUsers: CustomUser[] = [
  {
    name: 'Salvatore Vadacca',
    email: 'salvatore.vadacca@dove.it',
    given_name: 'Salvatore',
    family_name: 'Vadacca',
    'https://backoffice.dove.it/roles': [UserRole.ADMIN],
  }, {
    name: 'Giulia Radice',
    email: 'giulia.radice@dove.it',
    given_name: 'Giulia',
    family_name: 'Radice',
    'https://backoffice.dove.it/roles': [UserRole.ADMIN],
  }, {
    name: 'Paolo Facchetti',
    email: 'paolo.facchetti@dove.it',
    given_name: 'Paolo',
    family_name: 'Facchetti',
    'https://backoffice.dove.it/roles': [UserRole.ADMIN],
  },
];

/**
 * @todo replace with actual users retrieved from auth0
 */
export const jobApplicationHrUsersOptions: SelectOption[] = removeNullAndUndefinedValues([
  {
    label: 'Non assegnato',
    value: '',
  },
  ...jobApplicationHrUsers.map((user) => ({
    label: user.name,
    value: user.email,
  })),
]);

/**
 * @todo replace with actual users retrieved from auth0
 */
export const jobApplicationAssigneeUsersOptions: SelectOption[] = removeNullAndUndefinedValues([
  {
    label: 'Non assegnato',
    value: '',
  },
  ...jobApplicationAssigneeUsers.map((user) => ({
    label: user.name,
    value: user.email,
  })),
]);

/**
 * @todo replace with actual users retrieved from auth0
 */
export const jobApplicationInterviewerUsersOptions: SelectOption[] = removeNullAndUndefinedValues([
  {
    label: 'Non assegnato',
    value: '',
  },
  ...jobApplicationAssigneeUsers.map((user) => ({
    label: user.name,
    value: user.email,
  })),
  ...jobApplicationHrUsers.map((user) => ({
    label: user.name,
    value: user.email,
  })),
]);

export const jobApplicationExperiencesRadioOptions = [
  {
    label: 'Nessuna',
    value: 'Nessuna',
  },
  {
    label: 'Da 1 a 3 anni',
    value: 'Da 1 a 3 anni',
  },
  {
    label: 'Da 4 a 10 anni',
    value: 'Da 4 a 10 anni',
  },
  {
    label: '+10 anni',
    value: '+10 anni',
  },
];
